import { SelectProjectForm } from './_components/select-project-form.component'

export const SelectProjectPage = () => {
  return <SelectProjectForm />
}
